const breadcrumb = {
  missions: 'Mission List',
  new: 'Mission Profile',
  details: 'Mission Profile',
  reupload: '',
};

const button = {
  backToList: 'Back to List',
  downloadMissionConfiguration: 'Download Mission configuration',
  downloadMissionProfile: 'Download Mission profile',
  updateMission: 'Update Mission',
  uploadMissionConfiguration: 'Upload Mission configuration',
  uploadNewMission: 'Upload New Mission',
};

const details = {
  airports: 'Airports',
  centerlines: 'Centerlines',
  jurisdictions: 'Jurisdictions',
  length: 'Length',
  loadingAirports: 'Loading Airports',
  loadingObstacles: 'Loading Obstacles',
  name: 'Nom',
  obstacles: 'Obstacles',
  pipelineCenterline: 'Pipeline Centerline',
  rightOfWay: 'ROW',
  rightOfWays: 'ROWs',
  routes: 'Routes',
  urbanArea: 'Restricted zone',
  urbanAreas: 'Restricted zones',
  workzone: 'Workzone',
  workzones: 'Workzones',
};

const message = {
  creationSuccess: 'Mission created successfully',
  deletionConfirmation: 'Do you want to delete this mission?',
  invalidPhoneNumberFormat: 'Invalid phone number format',
  updateSuccess: 'Mission updated successfully',
  uploadPrompt: 'Please upload a mission configuration file',
  uploadSuccess: 'File uploaded successfully',
  sharedRow: 'This mission contains shared ROWs',
};

const table = {
  email: 'Email',
  id: 'ID',
  name: 'Name',
  phone: 'Phone',
};

export default {
  breadcrumb,
  contactsPerJurisdictions: 'Contacts per Jurisdiction',
  createMission: 'Create Mission',
  createSharedMission: 'Create Shared Mission',
  id: 'Id',
  name: 'Mission Name',
  daysSinceFlown: 'Days Since Flown',
  notFlown: 'Not Flown',
  sharedROW: 'Shared ROW',
  removeObstacles: 'Remove obstacles',
  button,
  details,
  editContactInformation: 'Edit Contact Information',
  newMission: 'New Mission',
  message,
  missionDetails: 'Mission Details',
  missionValidated: 'Mission Validated',
  table,
};
